import {
    VENDOR_PF_SCHEDULE_FETCHING,
    VENDOR_PF_SCHEDULE_SUCCESS,
    VENDOR_PF_SCHEDULE_FAILED
} from '../actions/types';

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case VENDOR_PF_SCHEDULE_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case VENDOR_PF_SCHEDULE_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case VENDOR_PF_SCHEDULE_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};